import { render, staticRenderFns } from "./ActivitySign.vue?vue&type=template&id=1c48113a&scoped=true"
import script from "./ActivitySign.vue?vue&type=script&lang=js"
export * from "./ActivitySign.vue?vue&type=script&lang=js"
import style0 from "./ActivitySign.vue?vue&type=style&index=0&id=1c48113a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c48113a",
  null
  
)

export default component.exports